import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'jrui-auth-google-button',
  templateUrl: './google-button.component.html',
  styleUrls: ['./google-button.component.scss', '../button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class GoogleButtonComponent {
  @Input() url = '';
  @Input() action = '';
}
